module.exports = __webpack_public_path__ + "static/media/account-logged.957dac7b.svg";